module.exports = __webpack_public_path__ + "img/audio-music.fccc7d8a.svg";